var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"close",on:{"click":_vm.onClose}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"main"},[_vm._t("main")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }